// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.w100[data-v-3bb7ee4c] {width: 100%;}\n.align-flex[data-v-3bb7ee4c] {display: flex; justify-content: center; align-items: baseline;}\n", ""]);
// Exports
module.exports = exports;
